import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "./authSlice";
import adaptiveboardReducer from "./adaptiveboard";
import groupchatReducer from "./groupchatSlice";
import memberReducer from "./../redux/Slices/memberSlice";
import productReducer from "./productSlice";
import productAccessReducer from "./productAccessSlice";

const appReducer = combineReducers({
  auth: authReducer,
  adaptiveboard: adaptiveboardReducer,
  groupchat: groupchatReducer,
  members: memberReducer,
  products: productReducer,
  productAccess: productAccessReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined; 
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["members"], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck:
        process.env.NODE_ENV !== "production"
          ? { warnAfter: 64 }
          : false,
    }),
});

export const persistor = persistStore(store);
